<template>
  <UTooltip
    :class="baseClass"
    :interactive="interactive"
    :placement="placement"
    :trigger="trigger"
    :popper="{
      placement,
    }"
  >
    <slot />

    <template #text>
      <div class="text-sm" v-html="text" />
    </template>
  </UTooltip>
</template>

<script>
export default {
  name: 'BTooltip',
  props: {
    text: {
      type: String,
      default: null
    },
    trigger: {
      type: String,
      default: 'mouseover, mouseleave, mouseenter'
    },
    placement: {
      type: String,
      default: 'top'
    },
    interactive: {
      type: Boolean,
      default: false
    },
    baseClass: {
      type: String,
      default: 'b-tooltip'
    }
  }
}
</script>
